import { render, staticRenderFns } from "./CRMActivity.vue?vue&type=template&id=6510d169&scoped=true&"
import script from "./CRMActivity.vue?vue&type=script&lang=js&"
export * from "./CRMActivity.vue?vue&type=script&lang=js&"
import style0 from "./CRMActivity.vue?vue&type=style&index=0&id=6510d169&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6510d169",
  null
  
)

export default component.exports